<template lang="pug">
#current_user
</template>

<script>

import { mapState } from 'vuex'

import Vue from 'vue'

export default {
  props: {
    current_user: { type: Object, default: [] },
  },
  async mounted(){
    await Vue.nextTick()
    //console.log(this.current_user)
    this.$store.commit("user/setPlanId", this.current_user.plan_id)
    this.$store.commit("user/setStripeCustomerId", this.current_user.stripe_customer_id)
  },
}
</script>
